export const networkClinicCopy = {
  dashboardTitle: 'Connect to Care',
  dashboardBookButton: 'Book Your Virtual Appointment with Kindbody',
  findClinic: 'Find a Kindbody Network Clinic',
  zipProceedLabel: 'Enter your ZIP code to proceed',
  searchOurNetwork: 'Search Our Network',
  virtualNpvName: 'Virtual New Patient Consult',
  zipIntro:
    'We offer access to more than 450 high quality, in-network fertility clinics across the country that accept your employer-sponsored benefit.',
  zipSteps: [
    'Enter your ZIP code to view nearby Kindbody network clinic options.',
    'Select a clinic that works best for you.',
    'Call the clinic to schedule your initial consultation.',
    'Mention your Kindbody benefits when scheduling.'
  ]
} as const;

export const NEW_PATIENT_CONSULT_NAME = 'New Patient Consult';
